<template>
  <b-collapse :id="`collapse-${id}`" class="mt-1">
    <ul class="dash-sub-list">
      <li class="dashboard-small" v-for="child in children" :key="child.id || child.name">
        <div v-if="child.children && child.children.length">
          <div v-if="checkAccess(child)">
            <a
              href="javascript:;"
              class="dash-nav-item is-parent"
              @click="customAction"
              v-b-toggle="`collapse-${child.id}`"
            >
              <b-icon class="dash-nav-icon" :icon="child.icon || 'folder2'"></b-icon>
              <span class="dash-nav-label">{{ child.name }}</span>
              <b-icon icon="chevron-down" class="dash-nav-chevron"></b-icon>
            </a>
            <sub-item :step="step+1" :id="child.id" :children="child.children"/>
          </div>
        </div>

        <div v-else>
          <router-link
            v-if="checkAccess(child)"
            class="dash-nav-item"
            :class="{ 'is-current': isCurrentChild(child) }"
            :to="routeManager(child)"
            exact
          >
              <b-icon class="dash-nav-icon" :icon="child.icon || 'circle'"></b-icon>
            <span class="dash-nav-label">{{ child.name }}</span>
            <b-icon icon="lock" v-if="!checkModuleActive(child)"/>
          </router-link>
        </div>
      </li>
    </ul>
  </b-collapse>
</template>

<script>
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";

export default {
  name: "subItem",
  props: ['children', 'id', 'step', 'action'],
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkAccess(item) {
      if (item.module === 'odoo_helpdesk') {
        if (process.env.VUE_APP_ODOO_HELPDESK_ENABLED === 'false') {
          return false
        }
        if (this.$store.getters['HelpdeskTicket/isEnabled'] === false) {
          return false
        }
      }
      let userProfile = this.$store.getters['User/getProfile'];
      let access = userProfile.meta?.find(item => item.name == 'user_access');
        let generalRoutes = ['Home', 'Dashboard', 'Profile', 'Address', 'UserOrders', 'LoansUser', 'UserChats', 'UserSubscription', 'HelpdeskTickets']
      if (access != undefined) {
        let values = JSON.parse(access.value).map(item => item.route)

        if (generalRoutes.indexOf(item.route.name) > -1) {
          return true
        }

        if (values.indexOf('*') > -1) {
          return true
        }
        return values.indexOf(item.route.name) > -1
      }

      return true
    },
    checkModuleActive(item) {
      if (process.env.NODE_ENV == 'development') {
        return true
      }
      if (item['module'] !== undefined) {
        return checkServiceIsExpire(item['module'])
      }
      return true
    },
    routeManager(item) {
      if (this.checkModuleActive(item)) {
        return item.route
      }
      return {name: "ModulesList"}
    },
    isCurrentChild(child) {
      const route = this.routeManager(child)
      return Boolean(route && route.name) && this.$route.name === route.name
    }
  },
}
</script>

<style scoped>
.dash-sub-list {
  list-style: none;
  margin: 0;
  padding: 0 0 4px 0;
}

.dashboard-small {
  list-style: none;
}

.dash-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  margin: 2px 0 2px 8px;
  padding: 7px 10px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.82) !important;
  text-decoration: none !important;
  font-size: 12.5px;
  line-height: 1.4;
}

.dash-nav-icon {
  flex-shrink: 0;
  font-size: 14px;
}

.dash-nav-label {
  flex: 1;
  min-width: 0;
  text-align: right;
}

.dash-nav-chevron {
  flex-shrink: 0;
  font-size: 11px;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.dash-nav-item:hover,
.dash-nav-item:focus {
  background: rgba(255, 255, 255, 0.08);
  color: #fff !important;
  outline: none;
}

.dash-nav-item.is-current {
  background: rgba(235, 61, 96, 0.92);
  color: #fff !important;
}

.not-collapsed .dash-nav-chevron {
  transform: rotate(180deg);
}
</style>
